// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3I7hQ","list":"BalanceDue_list__2v7PV","listRow":"BalanceDue_listRow__1Dfld","total":"BalanceDue_total__2-lmn"};